<template>
    <div>
        <!--<broadstreet-zone zone-id="77572"></broadstreet-zone>-->
        <broadstreet-zone zone-id="88941"></broadstreet-zone>
        <!-- <broadstreet-zone zone-id="77573"></broadstreet-zone>-->
        <broadstreet-zone zone-id="88942"></broadstreet-zone>

        <header>
            <div
                v-if="contest.main_image"
                class="header-image"
            >
                <img
                    :src="contest.main_image.large"
                />
            </div>
            <nav class="action-nav">
                <ul
                    class="menu-primary"
                    style="display: flex"
                >
                    <li v-if="contest && submitFormVisible">
                        <router-link :to="'/contests/' + contest.slug + '/entries/create'">
                            Enter
                        </router-link>
                    </li>
                    <!-- about page -->
                    <li v-if="(contest.settings && contest.settings.aboutPage == true)">
                        <router-link :to="'/contests/' + contest.slug + '/about'">About</router-link>
                    </li>
                    <!-- Gallery -->
                    <li>
                        <router-link :to="'/contests/' + contest.slug + '/entries'">
                            {{ gallery_or_vote }}
                        </router-link>
                    </li>
                    <!-- Rules -->
                    <li>
                        <router-link :to="'/contests/' + contest.slug + '/rules'">Rules</router-link>
                    </li>
                    <!-- Tips -->
                    <li v-if="contest.tips_content">
                        <router-link :to="'/contests/' + contest.slug + '/help'">Tips</router-link>
                    </li>
                    <!-- Finalists -->
                    <li v-if="(user && user.admin_level >= 10) && (contest.settings && contest.settings.finalists === 'true')">
                        <router-link :to="'/contests/' + contest.slug + '/finalists'">Finalists</router-link>
                    </li>
                    <!-- Prizes -->
                    <li v-if="contest.prizes_content">
                        <router-link :to="'/contests/' + contest.slug + '/prizes'">Prizes</router-link>
                    </li>
                </ul>
            </nav>
        </header>
    </div>
</template>
<script>
import {ENV_URL, S3_URL, MAIN_URL, STRIPE_PUBLISHABLE} from '../../environment.js';
import {mapState, mapGetters} from "vuex";

export default {
    data() {
        return {
            open: true,
            S3_URL: S3_URL,
        }
    },
    computed: {
        ...mapState({
            contest: (state) => state.contest,
            user: (state) => state.user,
        }),
        ...mapGetters({
            submitFormVisible: 'submitFormVisible',
        }),
        gallery_or_vote() {
            return this.gallery_or_vote_item();
        },
    },
    methods: {
        pluralize: n => n + (n === 1 ? ' reply' : ' replies'),
        gallery_or_vote_item() {
            let output = '';
            let contest = this.contest;
            var user_level = this.user !== null ? this.user.admin_level : 0;

            if (contest.status) {
                output = contest.status.toLowerCase() !== "vote" ? "Gallery" : "Vote";
                if (contest.id !== 6) {
                    return output;
                } else {
                    output = user_level >= 10 ? "Vote" : "Gallery";
                }
            }
            return output;
        }
    },
}
</script>

<style lang="scss">
broadstreet-zone-container {
    text-align: center;
    margin-bottom: 15px;
}

ul.menu-primary {
    li :hover {
        color: #000;
        background-color: #f5d67a;
    }
}

/**.router-link-exact-active
.router-link-active */
.router-link-exact-active {
    color: #000;
    background-color: #f5d67a;
}
</style>
